import { all, call, put, takeLatest } from 'redux-saga/effects';
import { NOTIFICATION_MESSAGES } from '../../localization/Notifications/dictionary';
import { ENTITY_TYPES_DICTIONARY } from '../../consts/dictionaries';
import { renderSuccessNotificationWithRedirect } from '../../helpers/notifications/renderSuccessNotificationWithRedirect';
import {
  getGeneralMessages,
  getGeneralMessagesSucceeded,
  getGeneralMessagesFailed,
  assignGeneralMessage,
  assignGeneralMessageSucceeded,
  assignGeneralMessageFailed,
  deleteGeneralMessage,
  deleteGeneralMessageSucceeded,
  deleteGeneralMessageFailed
} from './slice';
import { onGetGeneralMessages, onUpdateGeneralMessage, onDeleteGeneralMessage } from './api';

function* getGeneralMessagesWorker() {
  try {
    const response = yield call(onGetGeneralMessages);
    yield put(getGeneralMessagesSucceeded(response.data));
  } catch {
    yield put(getGeneralMessagesFailed());
  }
}

function* assignGeneralMessageWorker({ payload }) {
  try {
    const { message, entityType, entityId, renderSuccessNotification, navigate, callback } = payload;
    const updatedMessage = { ...message, [`${entityType}_id`]: entityId };
    const response = yield call(onUpdateGeneralMessage, updatedMessage);
    yield put(assignGeneralMessageSucceeded(response.data));
    callback?.();
    if (renderSuccessNotification) {
      const notificationMessage = NOTIFICATION_MESSAGES.assign_message_success;
      const notificationButtonLabel = `${ENTITY_TYPES_DICTIONARY[entityType]} ansehen`;
      renderSuccessNotificationWithRedirect(
        notificationMessage,
        notificationButtonLabel,
        `/${entityType}/${entityId}/main`,
        navigate
      );
    }
  } catch {
    yield put(assignGeneralMessageFailed());
  }
}

function* deleteGeneralMessageWorker({ payload }) {
  try {
    const { messageId, callback } = payload;
    const response = yield call(onDeleteGeneralMessage, messageId);
    yield put(deleteGeneralMessageSucceeded(response.data));
    callback?.();
  } catch {
    yield put(deleteGeneralMessageFailed());
  }
}

function* reloadGeneralMessagesWorker() {
  yield put(getGeneralMessages());
}

export default function* generalMessagesSaga() {
  yield all([
    takeLatest(getGeneralMessages.type, getGeneralMessagesWorker),
    takeLatest(assignGeneralMessage.type, assignGeneralMessageWorker),
    takeLatest(deleteGeneralMessage.type, deleteGeneralMessageWorker),
    takeLatest(assignGeneralMessageSucceeded.type, reloadGeneralMessagesWorker),
    takeLatest(deleteGeneralMessageSucceeded.type, reloadGeneralMessagesWorker)
  ]);
}
